import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      redirect: '/login'
    },
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      component: resolve => require(['../views/login/Login.vue'], resolve),
    },
    {
      path: '/noaccountconfig',
      component: resolve => require(['../views/login/NoAccountConfig.vue'], resolve),
    },
    {
      path: '/home',
      component: resolve => require(['../views/layout/Home.vue'], resolve),
      children: 
      [
        {
          path: '/account',
          component: resolve => require(['../views/account/Account.vue'], resolve)
        },
        {
          path: '/accountdetail',
          component: resolve => require(['../views/account/AccountDetail.vue'], resolve)
        },
        {
          path: '/database',
          component: resolve => require(['../views/system/Database.vue'], resolve)
        },
        {
          path: '/device',
          component: resolve => require(['../views/system/Device.vue'], resolve)
        },
        {
          path: '/system',
          component: resolve => require(['../views/system/System.vue'], resolve)
        },
        {
          path: '/file',
          component: resolve => require(['../views/system/File.vue'], resolve)
        },
        {
          path: '/filedetail',
          component: resolve => require(['../views/system/FileDetail.vue'], resolve)
        },
        {
          path: '/version',
          component: resolve => require(['../views/system/Version.vue'], resolve)
        },
        {
          path: '/versiondetail',
          component: resolve => require(['../views/system/VersionDetail.vue'], resolve)
        },
        {
          path: '/callboard',
          component: resolve => require(['../views/system/Callboard.vue'], resolve)
        },
        {
          path: '/callboarddetail',
          component: resolve => require(['../views/system/CallboardDetail.vue'], resolve)
        },
        {
          path: '/keyholdermap',
          component: resolve => require(['../views/system/KeyHolderMap.vue'], resolve)
        },
        {
          path: '/keyholdermapdetail',
          component: resolve => require(['../views/system/KeyHolderMapDetail.vue'], resolve)
        },
        {
          path: '/testnewcdlock',
          component: resolve => require(['../views/system/TestNewCDLock.vue'], resolve)
        },
        {
          path: '/testnewcdlockdetail',
          component: resolve => require(['../views/system/TestNewCDLockDetail.vue'], resolve)
        },
        {
          path: '/project',
          component: resolve => require(['../views/project/Project.vue'], resolve)
        },
        {
          path: '/projectdetail',
          component: resolve => require(['../views/project/ProjectDetail.vue'], resolve)
        },
        {
          path: '/projectconfig',
          component: resolve => require(['../views/project/ProjectConfig.vue'], resolve)
        },
        {
          path: '/projecttemplate',
          component: resolve => require(['../views/project/Template.vue'], resolve)
        },
        {
          path: '/projecttemplatedetail',
          component: resolve => require(['../views/project/TemplateDetail.vue'], resolve)
        },
        {
          path: '/accountreport',
          component: resolve => require(['../views/report/AccountReport.vue'], resolve)
        },
        {
          path: '/projectreport',
          component: resolve => require(['../views/report/ProjectReport.vue'], resolve)
        },
        {
          path: '/donglereport',
          component: resolve => require(['../views/report/DongleReport.vue'], resolve)
        },
        {
          path: '/lockreport',
          component: resolve => require(['../views/report/LockReport.vue'], resolve)
        },
        {
          path: '/keyreport',
          component: resolve => require(['../views/report/KeyReport.vue'], resolve)
        },
        {
          path: '/licensecodereport',
          component: resolve => require(['../views/report/LicenseCodeReport.vue'], resolve)
        },
        {
          path: '/onureport',
          component: resolve => require(['../views/report/OnuReport.vue'], resolve)
        },{
          path: '/lidreport',
          component: resolve => require(['../views/report/LidReport.vue'], resolve)
        },
        {
          path: '/nbpanellockreport',
          component: resolve => require(['../views/report/NBPanelLockReport.vue'], resolve)
        },
        {
          path: '/normalfsureport',
          component: resolve => require(['../views/report/NormalFSUReport.vue'], resolve)
        },
        {
          path: '/powerboardreport',
          component: resolve => require(['../views/report/PowerBoardReport.vue'], resolve)
        },
        {
          path: '/expandboardreport',
          component: resolve => require(['../views/report/ExpandBoardReport.vue'], resolve)
        },
        {
          path: '/blekeyreport',
          component: resolve => require(['../views/report/BleKeyReport.vue'], resolve)
        },
        {
          path: '/sharekeyreport',
          component: resolve => require(['../views/report/ShareKeyReport.vue'], resolve)
        },
        {
          path: '/oldblekeyreport',
          component: resolve => require(['../views/report/OldBleKeyReport.vue'], resolve)
        },
        {
          path: '/newclockreport',
          component: resolve => require(['../views/report/NewCLockReport.vue'], resolve)
        },
        {
          path: '/newdlockreport',
          component: resolve => require(['../views/report/NewDLockReport.vue'], resolve)
        },
        {
          path: '/pincodedlockreport',
          component: resolve => require(['../views/report/PincodeDLockReport.vue'], resolve)
        },
        {
          path: '/blankruncylinderreport',
          component: resolve => require(['../views/report/BlankRunCylinderReport.vue'], resolve)
        },
        {
          path: '/cabinetlockreport',
          component: resolve => require(['../views/report/CabinetLockReport.vue'], resolve)
        },
        {
          path: '/hotspotreport',
          component: resolve => require(['../views/report/HotspotReport.vue'], resolve)
        },
        {
          path: '/pincodepanelreport',
          component: resolve => require(['../views/report/PincodePanelReport.vue'], resolve)
        },
        {
          path: '/keyholderreport',
          component: resolve => require(['../views/report/KeyHolderReport.vue'], resolve)
        },
        {
          path: '/blelockreport',
          component: resolve => require(['../views/report/BleLockReport.vue'], resolve)
        },
        {
          path: '/dongleuse',
          component: resolve => require(['../views/report/DongleUse.vue'], resolve)
        },
        {
          path: '/donglebill',
          component: resolve => require(['../views/bill/DongleBill.vue'], resolve)
        },
        {
          path: '/licensecodebill',
          component: resolve => require(['../views/bill/LicenseCodeBill.vue'], resolve)
        },
        {
          path: '/nbiot',
          component: resolve => require(['../views/tool/NBIoT.vue'], resolve)
        },
        {
          path: '/encrypt',
          component: resolve => require(['../views/tool/Encrypt.vue'], resolve)
        },
        {
          path: '/doormanagermainreport',
          component: resolve => require(['../views/report/DoorManagerMainReport.vue'], resolve)
        },
        {
          path: '/doormanagerreaderreport',
          component: resolve => require(['../views/report/DoorManagerReaderReport.vue'], resolve)
        },
        {
          path: '/invoice',
          component: resolve => require(['../views/report/Invoice.vue'], resolve)
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js